import { render, staticRenderFns } from "./TeamLibrarySelector.vue?vue&type=template&id=20c24164&"
import script from "./TeamLibrarySelector.vue?vue&type=script&lang=js&"
export * from "./TeamLibrarySelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports